import { render, staticRenderFns } from "./SlrcN_InvoiceList.vue?vue&type=template&id=10023673"
import script from "./SlrcN_InvoiceList.vue?vue&type=script&lang=js"
export * from "./SlrcN_InvoiceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports